import type { GridSize } from "../core/types";

/** Tek karede tüm çizimin kullandığı yerleşim ölçüleri (CSS piksel). */
export interface ViewLayout {
  cell: number;
  offX: number;
  offY: number;
  headerH: number;
  width: number;
  height: number;
}

/** Grid + ekran boyutu → çizim yerleşimi. Oyun sırasında grid sabit kalır. */
export function computeLayout(width: number, height: number, grid: GridSize): ViewLayout {
  // Üst başlık ~1.6 hücre + kenar payları ~1-3 hücre
  const cell = Math.max(6, Math.floor(Math.min(width / (grid.cols + 1), height / (grid.rows + 3))));
  const headerH = cell * 1.6;
  const offX = Math.floor((width - grid.cols * cell) / 2);
  const offY = Math.max(cell * 0.4, Math.floor((height - (headerH + grid.rows * cell)) / 2));
  return { cell, offX, offY, headerH, width, height };
}
